import { FamilyTreeEffectsMap, FamilyTreeOnAfterEditOptions } from '../types';
import { useCompleteInitialiationEffect } from './completeInitialization.effect';
import { useFitViewEffect } from './fitView.effect';
import { useMarriageLayoutEffect } from './marriageLayout.effect';
import { useSaveNodeConfigEffect } from './saveNodeConfig.effect';
import { useSaveNodePositionsEffect } from './saveNodePositions.effect';
import { useSaveVisualizationConfigEffect } from './saveVisualizationConfig.effect';

export function useEffectsMap({
  onAfterEdit,
}: FamilyTreeOnAfterEditOptions = {}): FamilyTreeEffectsMap {
  const completeInitializationEffect = useCompleteInitialiationEffect();
  const fitViewEffect = useFitViewEffect();
  const marriageLayoutEffect = useMarriageLayoutEffect();
  const saveVisualizationConfigEffect = useSaveVisualizationConfigEffect();
  const saveNodeConfigEffect = useSaveNodeConfigEffect({ onAfterEdit });
  const saveNodePositionsEffect = useSaveNodePositionsEffect();

  return {
    completeInitializationEffect,
    fitViewEffect,
    marriageLayoutEffect,
    saveVisualizationConfigEffect,
    saveNodeConfigEffect,
    saveNodePositionsEffect,
  };
}
